import { StandardEntity } from '@infodata-group/inf-commons';
import { FleetDto } from '../interface/fleet.dto';

export class Fleet extends StandardEntity {
  public group: {
    id: string;
    label: string;
  };
  public isSpeedNull: boolean;
  public speedNullTime: number;
  public speedNullKmh: number;
  public driverId: string;
  public driverLabel: string;
  public vehicleId: string;
  public vehicleLabel: string;
  public vehicleBrand: string;
  public vehicleModel: string;
  public totalExpenses: number;
  public nextRevision: string;
  public createdAt: string;
  public alarm: string;
  public activeIdentification: boolean;
  public latitude: number;
  public longitude: number;
  public isEngin: boolean;

  constructor() {
    super();
  }

  public override serialize(): FleetDto {
    return {
      id: this.id,
      label: this.label,
      icon: this.icon,
      group: this.group,
      isSpeedNull: this.isSpeedNull,
      speedNullTime: this.speedNullTime,
      speedNullKmh: this.speedNullKmh,
      driverId: this.driverId,
      driverLabel: this.driverLabel,
      vehicleId: this.vehicleId,
      vehicleLabel: this.vehicleLabel,
      vehicleBrand: this.vehicleBrand,
      vehicleModel: this.vehicleModel,
      totalExpenses: this.totalExpenses,
      nextRevision: this.nextRevision,
      createdAt: this.createdAt,
      alarm: this.alarm,
      activeIdentification: this.activeIdentification,
      latitude: this.latitude,
      longitude: this.longitude,
      isEngin: this.isEngin,
    };
  }
}
